module.exports = __webpack_public_path__ + "img/started.82f4415a.svg";